import { FC, MouseEvent } from "react"
import classNames from "classnames"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import { PageRoutes } from "@/constants/routes"
import { UserRole } from "@/types/user"

export enum MenuItemKey {
   TENANT_ADMIN = "tenant-admin",
   FLOOR_OVERVIEW = "floor-overview",
   WEARABLES_OVERVIEW = "reassureband-overview",
   HOME = "home",
   DEMO = "demo",
   LOGOUT = "logout",
   SETTINGS = "settings",
   PREFERENCES = "preferences",
}

export enum MenuItemVisibility {
   CUSTOM = "custom",
   ALL = "all",
}

export interface MenuItemProps {
   key: MenuItemKey
   route?: keyof typeof PageRoutes | undefined
   label: string
   icon: IconProps["name"]
   active?: boolean
   visibility?: MenuItemVisibility
   onClick?: (e: MouseEvent) => void
   roles?: UserRole[]
}

const MenuItem: FC<MenuItemProps> = ({ label, icon, active, onClick }) => {
   return (
      <li
         className={classNames("menu-item", { "menu-item--active": active })}
         onClick={onClick}
      >
         <Icon
            size="16"
            name={icon}
            color={IconColor.COOL_GRAY}
         />
         <span>{label}</span>
      </li>
   )
}

export default MenuItem
